var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSingleinstrument = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "36px",
    viewBox: "0 0 28 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uD83D\uDD39 Icon Color")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Editor-/-monetization_on",
    transform: "translate(-9.000000, -5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-turned_in_not"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5833333,5.75 L13.4166667,5.75 C11.3083333,5.75 9.6025,7.475 9.6025,9.58333333 L9.58333333,40.25 L23,34.5 L36.4166667,40.25 L36.4166667,9.58333333 C36.4166667,7.475 34.6916667,5.75 32.5833333,5.75 Z M32.5833333,34.5 L23,30.3216667 L13.4166667,34.5 L13.4166667,9.58333333 L32.5833333,9.58333333 L32.5833333,34.5 Z",
    id: "\\uD83D\\uDD39-Icon-Color"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSingleinstrument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/singleinstrument.68972b0d.svg";
export { ForwardRef as ReactComponent };